module.exports = __webpack_public_path__ + "img/radiobutton-icon.26371207.svg";